import { applyUsableFilters, generateErrors, isFeatureEnabled } from 'utilities/util';
import { IStore } from 'reducers/index';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/equipments';
import { callApiV3Get, callApiV2Post, callApiV2Get } from 'utilities/apiCaller';
import API from 'constants/api';
import { TYPES as FILTER_TYPES } from 'action-types/filters';
import { TransportMode } from 'constants/modes';
import { FEATURE_TOGGLES } from 'constants/featureToggles';

export const resetEquipments = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.RESET_EQUIPMENTS.PENDING });
        dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: 0 });
        dispatch({ type: TYPES.RESET_EQUIPMENTS.FULFILLED, equipments: [] });
    }
};
export const fetchEquipments = (pageNumber?: number, pageSize?: number, genericFilter?: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.FETCH_EQUIPMENTS.PENDING });
        try {
            const res = await callApiV2Post(API.Equipment.EquipmentSearch,
                    applyUsableFilters(getState, {
                        Page: pageNumber,
                        PageSize: pageSize
                    }), {});
            dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: res.data.totalCount });
            dispatch({ type: TYPES.FETCH_EQUIPMENTS.FULFILLED, equipments: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_EQUIPMENTS.REJECTED, errors });
        }
    }
};
export const getEquipmentDetails = (equipmentId: number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.FETCH_EQUIPMENT_DETAILS.PENDING });
        try {
            const res = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_WEBAPI_EQUIPMENT_DETAILS, getState().featureToggle.featureToggles)
                ? await callApiV2Get(`${API.Equipment.EquipmentDetails}/${equipmentId}`, {}, {})
                : await callApiV3Get(`${API.Equipment.GetEquipmentDetails}/${equipmentId}`, {}, { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: TYPES.FETCH_EQUIPMENT_DETAILS.FULFILLED, response: res.data });
        } catch (e) {
            // Red List (ISCMLP-149314): the details endpoint returns 404 to hide equipment the
            // caller isn't allowed to see. Treat 404/403 as "no access" and block the whole page
            // instead of rendering a partial view driven by the (unfiltered) header call.
            const status = (e as any)?.response?.status;
            if (status === 404 || status === 403) {
                dispatch({ type: TYPES.EQUIPMENT_ACCESS_DENIED });
                return;
            }
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_EQUIPMENT_DETAILS.REJECTED, errors });
        }
    }
};

export const getEquipmentsHeader = (equipmentId: number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_EQUIPMENT_HEADER.PENDING });
        try {
            const res = await callApiV3Get(`${API.CostRevenueNew.getEquipmentsHeader}/${equipmentId}`, {}, { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: TYPES.FETCH_EQUIPMENT_HEADER.FULFILLED, equipmentHeader: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_EQUIPMENT_HEADER.REJECTED, errors });
        }
    }
};

export const fetchEquipmentChargesDetails = (equipmentId: number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_EQUIPMENT_CHARGES.PENDING });
        try {
            const res = await callApiV3Get(`${API.CostRevenueNew.getEquipmentsHeader}/${equipmentId}/costandrevenuesplits`, {}, { headers: { TransportMode: TransportMode.Ocean } });
            dispatch({ type: TYPES.FETCH_EQUIPMENT_CHARGES.FULFILLED, equipmentCostAndRevenueSplits: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_EQUIPMENT_CHARGES.REJECTED, errors });
        }
    }
};
